export const residentialPlanPricing = [
  {
    id: "residentialunlimited",
    name: "residentialPlan",
    price: "10,000",
    month: "mois",
    plan: "RÉSIDENTIEL ILLIMITÉ",
    setup: "10000",
    class: "col take-down mb-5",
    type: "Unlimited Internet",
    duration: false,
    cust: "24/7 Support",
    time: " Premier mois GRATUIT",
    popular: false,
    value: "home",
  },
  {
    id: "residentialpro",
    name: "residentialPlan",
    price: "60,000",
    month: "6 mois",
    plan: "PRO RÉSIDENTIEL",
    class: "col",
    setup: "10000",
    time: "  Premier mois GRATUIT",
    type: "Unlimited Internet",
    duration: true,
    cust: "24/7 Support",
    popular: true,
    value: "home",
  },
  {
    id: "residentialyearly",
    name: "residentialPlan",
    price: "120,000",
    month: "12 mois",
    class: "col take-down ",
    time: " 2 premiers mois GRATUITS",
    plan: "RÉSIDENTIEL À L'ANNÉE",
    setup: "10000",
    type: "Unlimited Internet",
    duration: true,
    cust: "24/7 Support",
    popular: false,
    value: "home",
  },
];

export const businessPlanPricing = [
  {
    id: "businessMax10Users",
    name: "businessPlan",
    price: "24,500",
    month: "mois",
    plan: "Plan d'affaires (1-10)Utilisateurs",
    setup: "10000",
    class: "col take-down mb-5",
    type: "Unlimited Internet",
    duration: false,
    cust: "24/7 Support",
    time: " Premier mois GRATUIT",
    popular: false,
    value: "office",
  },
  {
    id: "businessMax15Users",
    name: "businessPlan",
    price: "29,500",
    month: "mois",
    plan: "Plan d'affaires (1-15)Utilisateurs",
    class: "col",
    setup: "10000",
    time: "  Premier mois GRATUIT",
    type: "Unlimited Internet",
    duration: true,
    cust: "24/7 Support",
    popular: true,
    value: "office",
  },
  {
    id: "businessMax20Users",
    name: "businessPlan",
    price: "34,500",
    month: "mois",
    class: "col take-down ",
    time: " 2 premiers mois GRATUITS",
    plan: "Plan d'affaires (1-20)Utilisateurs",
    setup: "10000",
    type: "Unlimited Internet",
    duration: true,
    cust: "24/7 Support",
    popular: false,
    value: "office",
  },
];
